import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const OhioStateUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Ohio State University"
      universityShortName="OSU"
      slug="ohio-state-university"
      seoTitle="Ohio State Study Rooms | OSU Thompson Library Study Spaces"
      seoDescription="Find study rooms at Ohio State including Thompson Library and Research Commons. Learn about noise zones, booking policies, and CSW as an online alternative."
      seoKeywords="Ohio State study rooms, OSU library, Thompson Library study rooms, Columbus study spaces, Buckeye study rooms"
      canonicalUrl="/study-room/ohio-state-university/"
      heroDescription="Discover OSU's diverse study spaces across eleven floors of Thompson Library and specialized branches."
      libraryWebsiteUrl="https://library.osu.edu"
      libraryWebsiteName="OSU Libraries"
      studySpaces={[
        {
          name: "Thompson Library - Multiple Floors",
          features: "11 floors with varying noise levels. Lower floors social, upper floors silent.",
          feedback: "Great variety. Buckeye and Grand Reading Rooms are popular quiet spots."
        },
        {
          name: "Research Commons",
          features: "Rooms for 4-12 people, up to 4 hours booking time.",
          feedback: "Ideal for group presentations and collaborative research."
        },
        {
          name: "Health Sciences Library",
          features: "7 study rooms, specialized for health science students.",
          feedback: "Quieter atmosphere, less crowded than Thompson."
        },
        {
          name: "18th Avenue Library",
          features: "Cozy environment with natural light near windows.",
          feedback: "Hidden gem with comfortable seating and fewer crowds."
        }
      ]}
      guideContent={
        <>
          <p>
            OSU Libraries offer group study rooms across several branches. The Research Commons has rooms for 4-12 people 
            that can be booked up to four hours. Different floors of Thompson Library provide noise-specific zones.
          </p>
          <p className="mt-4">
            Students love the variety: Thompson Library's eleven floors range from collaborative spaces to hushed reading rooms. 
            Some rooms lack soundproofing, so conversations may leak out.
          </p>
          <p className="mt-4">
            Book a Research Commons room for group presentations; for silent study try Thompson's Buckeye Reading Room 
            or the quieter upper floors. Bring noise-cancelling headphones or choose open desk areas if rooms seem echoey.
          </p>
        </>
      }
      summaryTips={[
        "Thompson Library has 11 floors with different noise levels",
        "Research Commons is best for group presentations",
        "Buckeye Reading Room offers silent study",
        "18th Avenue Library is a quieter hidden gem",
        "Bring noise-cancelling headphones for rooms with thin walls"
      ]}
    />
  );
};

export default OhioStateUniversity;
